const addUseTag = svg => {
    const use = document.createElementNS("http://www.w3.org/2000/svg","use");
    use.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href', svg.dataset.src);
    // Pass switch icon if available
    if (svg.dataset.hasOwnProperty('switchIcon')) {
        use.setAttribute('data-switch-icon', svg.dataset.switchIcon);
    }
    svg.appendChild(use);
};

const updateUseTag = svg => {
    const newSrc = svg.dataset.src;
    const use = Array.from(svg.getElementsByTagName('use'));
    use.forEach(child => child.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href', newSrc));
};

const removeUseTag = svg => {
    const use = Array.from(svg.getElementsByTagName('use'));
    use.forEach(child => child.remove());
};

const justIntersected = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            addUseTag(entry.target);
            observer.unobserve(entry.target);
        }
    });
}

const resolveTargets = el => {
    // If this directive is used on a svg, it targets only the current element
    // Otherwise it targets the svg descendants
    return el.tagName === 'svg' ? [el] : Array.from(el.querySelectorAll("svg[data-src]"));
}

const globalObserver = "IntersectionObserver" in window ? new IntersectionObserver(justIntersected) : {
    // Some fallback functions in case we don't have access to the IntersectionObserver API
    observe: el => updateUseTag(el),
    unobserve: () => {},
};

export default {
    bind(el) {
        resolveTargets(el).forEach(svg => globalObserver.observe(svg));
    },

    componentUpdated(el) {
        resolveTargets(el).forEach(svg => updateUseTag(svg));
    },

    unbind(el) {
        resolveTargets(el).forEach(svg => {
            globalObserver.unobserve(svg);
            removeUseTag(svg);
        });
    },
}
